import React from 'react';

import cx from 'classnames';

import Icon from 'components/shared/Icon';
import Left from 'components/shared/Icon/icons/Left';
import { Eye, EyeSlash } from 'components/shared/Icon/phosphorIcons';
import Tooltip, { TooltipText } from 'components/shared/Tooltip';
import Text from 'components/shared/Typography/Text';
import { getEyeTooltipMsg } from 'utils/itineraries/functions/utils';

import { IContentLinkProps } from '../types';
import s from './index.module.css';

export const ContentLink = ({ link, activeLinkId }: IContentLinkProps) => {
  const EyeComp = link.isHidden ? EyeSlash : Eye;
  const iconId = `hide_icon${link.id}${link.isHidden}`;

  return (
    <>
      <div className={s.link}>
        <Text accent size="medium" className={cx(s.linkText, link.id === activeLinkId && s.active)}>
          <div className={cx(s.linkPageName, link.isHidden && s.crossedOutLine)} onClick={() => link.onClick(link.id)}>
            {link.builderTitle || link.name || 'Page Name'}
          </div>
        </Text>
        <div className={cx(s.eyeContainer, link.isHidden && s.visible)}>
          <EyeComp data-for={iconId} data-tip className={s.eye} size={20} onClick={() => link.onHide?.(link.id)} />
        </div>
        <Icon component={Left} width="0.7rem" height="1.3rem" className={s.linkIcon} />
      </div>
      <Tooltip place="top" id={iconId} key={iconId}>
        <TooltipText>
          <div style={{ minWidth: 100 }}>
            <p style={{ whiteSpace: 'pre-line', textAlign: 'center', fontWeight: '500' }}>{getEyeTooltipMsg(link)}</p>
          </div>
        </TooltipText>
      </Tooltip>
    </>
  );
};
